import { modalController } from '@ionic/core';
import { FileDoc } from 'common';

export class DocumentViewerModalController {
  static async present(projectId: string, file: FileDoc, cssClass: string = 'modal-size-90'): Promise<boolean> {
    const modal = await modalController.create({
      component: 'document-viewer-modal',
      componentProps: { projectId, file, fullScreen: cssClass === 'modal-full-view' },
      cssClass: cssClass,
    });

    return new Promise<boolean>(resolve => {
      modal.addEventListener('dismiss', () => {
        modal.dismiss();
        resolve(false);
      });
      modal.present();
    });
  }
}
